// extracted by mini-css-extract-plugin
export default {"notFound404":"NotFound404_notFound404__Csq+V"};